// TypeScript React
import React, { useState } from 'react';
import { Collapse, Typography, Link, Box, IconButton } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { AgentDetails } from '../../../hooks/EdisonAgent';

interface Props {
    details?: AgentDetails;
}

const EdisonDetailsPanel: React.FunctionComponent<Props> = (props) => {
    const { details } = props;
    const [expanded, setExpanded] = useState(false);
    const [toolUseExpanded, setToolUseExpanded] = useState(false);

    if (!details) return null;

    console.log('tool result', details.toolResult);
    return (
        <Box sx={{ mt: 1, borderTop: '1px solid', borderColor: 'divider', pt: 1 }}>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    '&:hover': { opacity: 0.7 },
                }}
                onClick={() => setExpanded(!expanded)}
            >
                <Typography variant="caption" sx={{ color: 'text.secondary', flex: 1 }}>
                    View details
                </Typography>
                <IconButton
                    size="small"
                    sx={{
                        transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
                        transition: 'transform 0.2s',
                    }}
                >
                    <ExpandMoreIcon fontSize="small" />
                </IconButton>
            </Box>
            <Collapse in={expanded}>
                <Box sx={{ mt: 1, pl: 1 }}>
                    {!!details.thinking && (
                        <Box sx={{ mb: 2 }}>
                            <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.secondary' }}>
                                Thinking
                            </Typography>
                            <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', mt: 0.5 }}>
                                {details.thinking}
                            </Typography>
                        </Box>
                    )}
                    {!!details.sql && (
                        <Box sx={{ mb: 2 }}>
                            <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.secondary' }}>
                                SQL
                            </Typography>
                            <Box
                                component="pre"
                                sx={{
                                    whiteSpace: 'pre-wrap',
                                    mt: 0.5,
                                    p: 1,
                                    bgcolor: 'grey.100',
                                    borderRadius: 1,
                                    fontSize: '0.75rem',
                                    overflow: 'auto',
                                }}
                            >
                                {details.sql}
                            </Box>
                        </Box>
                    )}
                    {!!details.toolResult && (
                        <Box sx={{ mb: 2 }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    cursor: 'pointer',
                                    '&:hover': { opacity: 0.7 },
                                }}
                                onClick={() => setToolUseExpanded(!toolUseExpanded)}
                            >
                                <Typography
                                    variant="caption"
                                    sx={{ fontWeight: 600, color: 'text.secondary', flex: 1 }}
                                >
                                    Tool Use
                                </Typography>
                                <IconButton
                                    size="small"
                                    sx={{
                                        transform: toolUseExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                                        transition: 'transform 0.2s',
                                    }}
                                >
                                    <ExpandMoreIcon fontSize="small" />
                                </IconButton>
                            </Box>
                            <Collapse in={toolUseExpanded}>
                                <Box sx={{ mt: 1 }}>
                                    {details.toolResult
                                        .filter((result) => !!result.sql)
                                        .map((result, idx) => (
                                            <Box key={idx} sx={{ mb: 1.5 }}>
                                                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                                    {result.name.toUpperCase()}
                                                </Typography>
                                                <Box
                                                    component="pre"
                                                    sx={{
                                                        whiteSpace: 'pre-wrap',
                                                        mt: 0.5,
                                                        p: 1,
                                                        bgcolor: 'grey.100',
                                                        borderRadius: 1,
                                                        fontSize: '0.75rem',
                                                        overflow: 'auto',
                                                    }}
                                                >
                                                    <Typography variant="body2">{result.sql}</Typography>
                                                </Box>
                                            </Box>
                                        ))}
                                </Box>
                            </Collapse>
                        </Box>
                    )}
                    {!!details.citations?.length && (
                        <Box sx={{ mb: 1 }}>
                            <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.secondary' }}>
                                Citations
                            </Typography>
                            <Box component="ul" sx={{ mt: 0.5, pl: 2, fontSize: '0.8rem' }}>
                                {details.citations.map((c, i) => (
                                    <li key={i}>
                                        {`[${i + 1}] `}
                                        {c.title ? <strong>{c.title}:</strong> : null}{' '}
                                        {c.url ? (
                                            <Link
                                                href={c.url}
                                                target="_blank"
                                                rel="noreferrer"
                                                sx={{ fontSize: '0.8rem' }}
                                            >
                                                {c.url}
                                            </Link>
                                        ) : null}
                                    </li>
                                ))}
                            </Box>
                        </Box>
                    )}
                </Box>
            </Collapse>
        </Box>
    );
};

export default EdisonDetailsPanel;
